/**
 * Older browsers (pre-2021, e.g. a 2019 Chrome crawler) have `crypto.getRandomValues`
 * but not `crypto.randomUUID`, so the web build threw
 * `TypeError: crypto.randomUUID is not a function` wherever an ID was generated
 * (expo-crypto's web `randomUUID()` and some libraries call it directly).
 * Fill it in with an RFC 4122 v4 UUID built from `getRandomValues`.
 * No-op on native and on browsers that already have it. Imported first in index.ts.
 */
type MaybeCrypto = {
  getRandomValues?: (array: Uint8Array) => Uint8Array;
  randomUUID?: unknown;
};

const webCrypto = (globalThis as unknown as { crypto?: MaybeCrypto }).crypto;

if (
  webCrypto &&
  typeof webCrypto.getRandomValues === "function" &&
  typeof webCrypto.randomUUID !== "function"
) {
  const getRandomValues = webCrypto.getRandomValues.bind(webCrypto);
  Object.defineProperty(webCrypto, "randomUUID", {
    configurable: true,
    writable: true,
    value: function randomUUID(): string {
      const bytes = getRandomValues(new Uint8Array(16));
      bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40; // version 4
      bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80; // RFC 4122 variant
      let hex = "";
      for (let i = 0; i < bytes.length; i++) {
        hex += (bytes[i] ?? 0).toString(16).padStart(2, "0");
      }
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    },
  });
}

export {};
